import { Text, View } from '@react-pdf/renderer';
import React, { FC } from 'react';
import { IntlFormatters } from '@formatjs/intl/src/types';
import { isEmpty } from 'lodash';

import messages from 'components/ProfileActions/messages';
import { styles } from './styles';

type ResumePdfLanguagesProps = {
  formatMessage: IntlFormatters['formatMessage'];
  profile: AH$Profile;
};

export const ResumePdfLanguages: FC<ResumePdfLanguagesProps> = ({ profile, formatMessage }) => {
  const { languages } = profile;

  if (!languages || isEmpty(languages)) {
    return null;
  }

  return (
    <View style={styles.section}>
      <Text style={[styles.subheading, styles.bold, styles.spaceBottomBig]}>
        {formatMessage(messages.languages)}
      </Text>
      {Object.keys(languages).map((language) => {
        const level = languages[language] || '';
        const formattedLevel = level ? `${level[0].toUpperCase()}${level.slice(1)}` : '';

        return (
          <Text style={[styles.text, styles.spaceBottom]}>
            {formattedLevel ? `${language} — ${formattedLevel}` : language}
          </Text>
        );
      })}
    </View>
  );
};
